import { Edit, SimpleForm, useGetIdentity, useGetOne, useNotify, useRedirect, useTranslate } from 'react-admin'
import Form from '../../inputFormComponents/Form'
import { apiService } from '../../apiService'
import { AddTextModelCommand, RemoveTextModelCommand, UserReadModel } from '../../GeneratedClients/FreeBillApi'
import { useMutation } from "react-query";
import TextModelEditActions from './TextModelEditActions'
import FormCardTextModel from '../../textModel/FormCardTextModel';
import textModelTemplate from '../../fixtures/textModelTemplate';
import TextModelEditToolBar from './TextModelEditToolBar';

const TextModelEdit = () => {

  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const { data: identity, isLoading } = useGetIdentity()
  const { data: user, isLoading: userLoading} = useGetOne("users", {id: identity?.id})
  const { mutate: addTextModel } = useMutation((command: AddTextModelCommand) => 
    apiService.UsersApi.addTextModel({addTextModelCommand: command, id: identity!.id.toString()})  
  )
  const { mutate: removeTextModel } = useMutation((command: RemoveTextModelCommand) => 
    apiService.UsersApi.removeTextModel({removeTextModelCommand: command, id: identity!.id.toString()})  
  )

  const handleSubmit = async(fieldValues: UserReadModel) => {
    fieldValues.textModel ? (
      addTextModel({userId: fieldValues.id, textModel: fieldValues.textModel}, {
        onSuccess() {
          notify(translate('ra.notification.updated', {smart_count: 1}))
          redirect(`/users/${fieldValues.id}/textModel`)
        },
        onError(error: any) {
          notify(error, {type: 'error'})
        },  
      })
    ) : (
      removeTextModel({userId: fieldValues.id}, {
        onSuccess() {
          notify(translate('ra.notification.deleted', {smart_count: 1}))
          redirect(`/users/${fieldValues.id}/textModel`)
        },
        onError(error: any) {
          notify(error, {type: 'error'})
        },  
      })
    )
  }

  if(isLoading || userLoading || !identity) return null

  const textModel = user?.textModel ? user.textModel : textModelTemplate
  const configTextModel = user?.textModel ? "show" : "hide"

  const cards = [<FormCardTextModel initConfigTextModel={configTextModel} textModel={textModel} />]

  return (
    <Edit 
      resource='users' 
      id={identity.id} 
      actions={<TextModelEditActions />}
      title={translate("resources.textTemplates.name", {smart_count: 2})}
    >
      <SimpleForm 
        onSubmit={handleSubmit} 
        toolbar={<TextModelEditToolBar />}
        defaultValues={{id: identity.id, configTextModel: configTextModel, textModel: textModel}}
      >
        <Form 
          cards={cards} 
        />
      </SimpleForm>
    </Edit>
  )
}

export default TextModelEdit